import request from "@/utils/request";

export function plateList(params) {
  return request.get('/web/category/plate', params, { login: false });
}

export function categoryList(params) {
  return request.get('/web/category/list', params, { login: false });
}

export function bannerAreaList(params) {
  return request.get('/web/banner', params, { login: false });
}
